import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { message } from 'antd';

export const downloadFileWithBlob = (csvData: string, fileName: string) => {
    try {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const downloadUrl = window.URL.createObjectURL(blob);

        // 创建一个隐藏的 <a> 元素
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName;

        // 将 <a> 元素添加到文档中并触发点击事件以启动下载
        document.body.appendChild(a);
        a.click();

        // 清理
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    } catch (e) {
        console.error(e);
    }
};

export const downloadZipWithBlob = (zipData: string, fileName: string) => {
    try {
        const blob = new Blob([zipData], { type: 'application/zip' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    } catch (e) {
        console.error(e);
    }
};

// `cache: 'no-store'` 强制绕开可能被同一 URL 的非 CORS <img> 预览污染过的 HTTP 缓存（那份缓存不含 CORS 头，会
// 导致带 crossOrigin 的请求失败），每次都发一个真正的 CORS 请求直连来源。
const fetchImageBytes = async (url: string): Promise<ArrayBuffer> => {
    const res = await fetch(url, { mode: 'cors', cache: 'no-store' });
    if (!res.ok) {
        throw new Error(`Failed to fetch image (${res.status}): ${url}`);
    }
    return res.arrayBuffer();
};

// 从 URL 推断扩展名（忽略预签名 query），推断不出时回退到 jpg。
const getExtFromUrl = (url: string): string => {
    const path = url.split('?')[0];
    const match = path.match(/\.([a-zA-Z0-9]+)$/);
    return match ? match[1].toLowerCase() : 'jpg';
};

export const handleDownloadPhoto = async (urls: string[], zipFileName: string) => {
    const validUrls = urls.filter((e) => !!e);
    if (validUrls.length === 0) {
        message.error('No image available to download.');
        return;
    }

    const zip = new JSZip();
    // 完成判定基于过滤后的数组，用 allSettled 等全部 settle，避免旧代码里
    // count === urls.length（原始长度）导致的漏触发/空 zip。
    const results = await Promise.allSettled(
        validUrls.map(async (url, index) => {
            const bytes = await fetchImageBytes(url);
            zip.file(`file-${index}.${getExtFromUrl(url)}`, bytes, { binary: true });
        }),
    );

    const succeeded = results.filter((r) => r.status === 'fulfilled').length;
    if (succeeded === 0) {
        results.forEach((r) => {
            if (r.status === 'rejected') {
                console.error('Error downloading image:', r.reason);
            }
        });
        message.error('Failed to download. Please try again.');
        return;
    }

    try {
        const zipFile = await zip.generateAsync({ type: 'blob' });
        saveAs(zipFile, `${zipFileName}.zip`);
    } catch (ex) {
        console.error(ex);
        message.error('Failed to package the download. Please try again.');
    }
};

// 私有上传组件（FileUploadPrivate）只给文件 key，原始文件名取 key 的最后一段
export const fileNameFromKey = (key?: string | null): string | null =>
    key ? key.split('?')[0].split('/').pop() || key : null;
